import { RoutesPath } from './routes-path';

export const ServicesMenu = [
  {
    groupName: 'MENU_MEMBERSHIP',
    isOpen: true,
    active: true,
    description:
      'This content will be specific to the service and limited to three lines.',
    services: [
      {
        serviceName: 'SR_MEMBERSHIP_REG',
        routerLink: RoutesPath.MEMBERSHIP.REGISTRATION,
        favourite: true,
        active: true,
      },
      {
        serviceName: 'SR_MEMBERSHIP_AMD',
        routerLink: RoutesPath.MEMBERSHIP.AMENDMENT,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_MEMBERSHIP_RENEW',
        routerLink: RoutesPath.MEMBERSHIP.RENEW,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_MEMBERSHIP_CANCELLATION',
        routerLink: RoutesPath.MEMBERSHIP.CANCELLATION,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_MEMBERSHIP_MANAGE_SIGNATORIES',
        routerLink: RoutesPath.MEMBERSHIP.MANAGE_SIGNATORIES,
        favourite: false,
        active: true,
      },
    ],
  },
  {
    groupName: 'MENU_CERTIFICATE_OF_ORIGIN',
    isOpen: false,
    active: true,
    description:
      'This content will be specific to the service and limited to three lines.',
    services: [
      {
        serviceName: 'SR_ISSUE_COO',
        routerLink: RoutesPath.COO.ISSUE,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_AMD_COO',
        routerLink: RoutesPath.COO.AMENDMENT,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_PERSONAL_COO',
        routerLink: RoutesPath.COO.PERSONAL,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_ISSUE_GSP_CERTIFICATE',
        routerLink: RoutesPath.COO.GSP_CERTIFICATE,
        favourite: false,
        active: true,
      },
    ],
  },
  {
    groupName: 'MENU_ATTESTATION_SERVICE',
    isOpen: false,
    active: true,
    description:
      'This content will be specific to the service and limited to three lines.',
    services: [
      {
        serviceName: 'SR_AUTHENTICATE_DOCUMENT',
        routerLink: RoutesPath.ATTESTATION.AUTHENTICATE,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_CERTIFY_DOCUMENT',
        routerLink: RoutesPath.ATTESTATION.CERTIFY,
        favourite: true,
        active: true,
      },
      {
        serviceName: 'SR_VERIFY_SIGNATURE',
        routerLink: RoutesPath.ATTESTATION.VERIFY_SIGNATURE,
        favourite: false,
        active: true,
      },
    ],
  },
  {
    groupName: 'MENU_ATA',
    isOpen: false,
    active: true,
    description:
      'This content will be specific to the service and limited to three lines.',
    services: [
      {
        serviceName: 'SR_ATA_CARNET_NEW',
        routerLink: RoutesPath.ATA.CARNET,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_ATA_CARNET_REFUND',
        routerLink: RoutesPath.ATA.REFUND,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_ATA_CARNET_NOC',
        routerLink: RoutesPath.ATA.NOC_LETTER,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_ATA_CARNET_AMD',
        routerLink: RoutesPath.ATA.AMENDMENT,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_ATA_CARNET_SUBS',
        routerLink: RoutesPath.ATA.SUBSTITUTE,
        favourite: false,
        active: true,
      },
      {
        serviceName: 'SR_ATA_CARNET_REPLACE',
        routerLink: RoutesPath.ATA.REPLACE,
        favourite: false,
        active: true,
      },
      // { serviceName: 'SR_ATA_CARNET_CANCEL', routerLink: RoutesPath.ATA.CANCEL, favourite: false, active: true }
    ],
  },
  {
    groupName: 'MENU_INFORMATION_SERVICE',
    isOpen: false,
    active: true,
    description:
      'This content will be specific to the service and limited to three lines.',
    services: [
      {
        serviceName: 'SR_INFORMATION_SERVICE',
        routerLink: RoutesPath.INFORMATION_SERVICE,
        favourite: false,
        active: true,
      },
    ],
  },
  {
    groupName: 'SR_MEDIATION_SERVICES',
    isOpen: false,
    active: true,
    description:
      'This content will be specific to the service and limited to three lines.',
    services: [
      {
        serviceName: 'SR_MEDIATION',
        routerLink: RoutesPath.MEDIATION,
        favourite: false,
        active: true,
      },
    ],
  },
  {
    groupName: 'MENU_BUSINESS_GROUP',
    isOpen: false,
    active: true,
    description:
      'This content will be specific to the service and limited to three lines.',
    services: [
      {
        serviceName: 'SR_BUSINESS_GROUP',
        routerLink: RoutesPath.BUSINESS_GROUPS_COUNCILS,
        favourite: false,
        active: true,
      },
    ],
  },
  {
    groupName: 'MENU_SUSTAINABILITY',
    isOpen: false,
    active: true,
    description:
      'This content will be specific to the service and limited to three lines.',
    services: [
      {
        serviceName: 'SR_APPLY_SUSTAINABILITY',
        routerLink: RoutesPath.SUSTAINABILITY,
        favourite: false,
        active: true,
      },
    ],
  },
  {
    groupName: 'SR_MYSTERY_SHOPPER_MEMBERSHIP',
    isOpen: false,
    active: true,
    description: '',
    services: [
      {
        serviceName: 'SR_MYSTERY_SHOPPER_MEMBERSHIP',
        routerLink: RoutesPath.MYSTERY_SHOPPER,
        favourite: false,
        active: true,
      },
    ],
  },
];

export const SideMenus = [
  {
    icon: 'svg/dashboard.svg',
    key: 'MENU_DASHBOARD',
    route: RoutesPath.DASHBOARD,
    active: true,
  },
  {
    icon: 'svg/flag.svg',
    key: 'MENU_APPLICATIONS',
    route: RoutesPath.APPLICATIONS,
    active: true,
  },
  {
    icon: 'svg/transactions.svg',
    key: 'MENU_PAYMENTS',
    route: RoutesPath.PAYMENTS,
    active: true,
  },
  {
    icon: 'svg/services.svg',
    key: 'MENU_SERVICES',
    route: RoutesPath.SERVICES_LIST,
    active: true,
  },
  {
    icon: 'svg/ata-carnet.svg',
    key: 'MENU_ATA',
    route: RoutesPath.ATA_CARNET,
    active: true,
  },
  {
    icon: 'svg/meditation.svg',
    key: 'MENU_MEDIATION',
    route: RoutesPath.MEDIATION,
    active: true,
  },
  {
    icon: 'svg/documents.svg',
    key: 'MENU_DOCUMENTS',
    route: RoutesPath.DOCUMENTS,
    active: true,
  },
  {
    icon: 'svg/venue.svg',
    key: 'MENU_VENUE',
    route: RoutesPath.SERVICE + '/' + RoutesPath.VENUE.VENUE_LIST,
    active: true,
  },
  {
    icon: 'svg/user.svg',
    key: 'MENU_ACCOUNT',
    route: RoutesPath.ACCOUNT_MANAGEMENT,
    active: true,
  },
  {
    icon: 'svg/business-group.svg',
    key: 'MENU_BUSINESS_GROUP',
    route: RoutesPath.BUSINESS_GROUPS_COUNCILS,
    active: true,
  },
  {
    icon: 'svg/transactions.svg',
    key: 'MENU_STATEMENT_OF_ACCOUNT',
    route: RoutesPath.STATEMENTS,
    active: true,
  },
  {
    icon: 'svg/mystery-shopper.svg',
    key: 'MENU_MYSTERY_SHOPPER',
    route: 'service-detail/mystery-shopper',
    active: true,
  },
  {
    icon: 'svg/mrm-award.svg',
    key: 'MENU_MRM_AWARDS',
    route: 'service-detail/mrm-award',
    active: true,
  },
  {
    icon: 'svg/chamber-entrepreneurship.svg',
    key: 'MENU_CHAMBER_ENTREPRENEURSHIP',
    route: 'service/chamber-entrepreneur',
    active: true,
  }
	  
];
